import { getReportParams, report } from 'app/middleware/report';

export function dwhViewUpdates(customerName, subscriber, idNumber, ban, psid, crmId, param1, param3, param9, param10) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'My Zone';
    reportParams.actionType = 'Messages Page';
    reportParams.status = 'Completed';
    reportParams.messageText = 'Messages Page Displayed';
    reportParams.param1 = param1; // כותרת העדכון שהיה ראשון שהוצג בלובי=עבור איזה עדכון נכנס
    reportParams.param3 = param3; // כמות העדכונים שהוצגו
    reportParams.param9 = param9;
    reportParams.param10 = param10;
    reportParams.customerName = customerName;
    reportParams.idNumber = idNumber;
    reportParams.subscriber = subscriber;
    reportParams.banId = ban;
    reportParams.psid = psid;
    reportParams.crmId = crmId;

    report(reportParams);
}

export function dwhViewUsageInCountry(customerName, subscriber, idNumber, ban, psid, crmId, param1, param9, param10) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'My Zone';
    reportParams.actionType = 'Usage Expand';
    reportParams.status = 'Completed';
    reportParams.messageText = 'Usage Expand Displayed';
    reportParams.param1 = param1; // מספר מנוי עבורו צפה
    reportParams.param9 = param9;
    reportParams.param10 = param10;
    reportParams.customerName = customerName;
    reportParams.idNumber = idNumber;
    reportParams.subscriber = subscriber;
    reportParams.banId = ban;
    reportParams.psid = psid;
    reportParams.crmId = crmId;

    report(reportParams);
}

export function dwhViewUsageAbroad(customerName, subscriber, idNumber, ban, psid, crmId, param1, param9, param10) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'My Zone';
    reportParams.actionType = 'MyZone Abroad Lobby';
    reportParams.status = 'Completed';
    reportParams.messageText = 'MyZone Abroad Usage Displayed';
    reportParams.param1 = param1; // מספר מנוי עבורו צפה
    reportParams.param9 = param9;
    reportParams.param10 = param10;
    reportParams.customerName = customerName;
    reportParams.idNumber = idNumber;
    reportParams.subscriber = subscriber;
    reportParams.banId = ban;
    reportParams.psid = psid;
    reportParams.crmId = crmId;

    report(reportParams);
}

export function dwhViewAbroadPackage(customerName, subscriber, idNumber, ban, psid, crmId, param1, param9, param10) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'My Zone';
    reportParams.actionType = 'MyZone Abroad Lobby';
    reportParams.status = 'Completed';
    reportParams.messageText = 'MyZone Abroad Package Displayed';
    reportParams.param1 = param1; // מספר מנוי עבורו צפה
    reportParams.param9 = param9;
    reportParams.param10 = param10;
    reportParams.customerName = customerName;
    reportParams.idNumber = idNumber;
    reportParams.subscriber = subscriber;
    reportParams.banId = ban;
    reportParams.psid = psid;
    reportParams.crmId = crmId;

    report(reportParams);
}

export function dwhViewAbroadAlert(customerName, subscriber, idNumber, ban, psid, crmId, param1, param2, param9, param10) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'My Zone';
    reportParams.actionType = 'MyZone Abroad Lobby';
    reportParams.status = 'Completed';
    reportParams.messageText = `MyZone Abroad Alert Displayed ${param1}`; // <alert text>
    reportParams.param1 = param1; // מספר מנוי עבורו צפה
    reportParams.param9 = param9;
    reportParams.param10 = param10;
    reportParams.customerName = customerName;
    reportParams.idNumber = idNumber;
    reportParams.subscriber = subscriber;
    reportParams.banId = ban;
    reportParams.psid = psid;
    reportParams.crmId = crmId;

    report(reportParams);
}

export function dwhViewMainLobby(customerName, subscriber, idNumber, ban, psid, crmId, param9, param10) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'My Zone';
    reportParams.actionType = 'MyZone Main Lobby';
    reportParams.status = 'Ongoing';
    reportParams.messageText = 'Main Lobby Displayed';
    reportParams.param9 = param9;
    reportParams.param10 = param10;
    reportParams.customerName = customerName;
    reportParams.idNumber = idNumber;
    reportParams.subscriber = subscriber;
    reportParams.banId = ban;
    reportParams.psid = psid;
    reportParams.crmId = crmId;

    report(reportParams);
}

export function dwhViewNonExistentProductLobby(customerName, subscriber, idNumber, ban, psid, crmId, param1, param9, param10) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'My Zone';
    reportParams.actionType = `MyZone ${param1} Lobby`; // <Cellular/Abroad/Internet/TV/Energy>
    reportParams.status = 'Completed';
    reportParams.messageText = `${param1} Not Exist Lobby Displayed`; // <Cellular/Abroad/Internet/TV/Energy>
    reportParams.param9 = param9;
    reportParams.param10 = param10;
    reportParams.customerName = customerName;
    reportParams.idNumber = idNumber;
    reportParams.subscriber = subscriber;
    reportParams.banId = ban;
    reportParams.psid = psid;
    reportParams.crmId = crmId;

    report(reportParams);
}

export function dwhViewPaymentMethods(customerName, subscriber, idNumber, ban, psid, crmId, param1, param9, param10) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'Update Payment Method';
    reportParams.actionType = 'Enter Update Payment';
    reportParams.status = 'Completed';
    reportParams.messageText = 'Enter Update Payment';
    reportParams.param1 = param1; // כמות אמצעי תשלום שהוצגו
    reportParams.param9 = param9;
    reportParams.param10 = param10;
    reportParams.customerName = customerName;
    reportParams.idNumber = idNumber;
    reportParams.subscriber = subscriber;
    reportParams.banId = ban;
    reportParams.psid = psid;
    reportParams.crmId = crmId;

    report(reportParams);
}

export function dwhViewServices(customerName, subscriber, idNumber, ban, psid, crmId, param1, param2, param9, param10) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'My Zone';
    reportParams.actionType = `MyZone ${param1} Lobby`; // <Cellular/Abroad/Internet/TV>
    reportParams.status = 'Ongoing';
    reportParams.messageText = `${param1} Lobby Displayed`;
    reportParams.param1 = param1; // מנוי סלולר/מוצר אינטרנט/TV <מספר מנוי/מזהה מוצר>
    reportParams.param2 = param2; // כמות שירותים קיימים שהוצגו
    reportParams.param9 = param9;
    reportParams.param10 = param10;
    reportParams.customerName = customerName;
    reportParams.idNumber = idNumber;
    reportParams.subscriber = subscriber;
    reportParams.banId = ban;
    reportParams.psid = psid;
    reportParams.crmId = crmId;

    report(reportParams);
}

export function dwhSelfcareActionGuideClick(worldType, customerName, subscriber, idNumber, ban, psid, crmId, param1, param2, param9, param10) {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'My Zone';
    reportParams.actionType = `MyZone Lobby`; // <Main/Cellular/Abroad/Internet/TV/Energy>
    reportParams.status = 'Ongoing';
    reportParams.messageText = 'Selfcare Action/Guide Clicked';
    reportParams.param1 = param1; // שם פעולה/מדריך
    reportParams.param9 = param9;
    reportParams.param10 = param10;
    reportParams.customerName = customerName;
    reportParams.idNumber = idNumber;
    reportParams.subscriber = subscriber;
    reportParams.banId = ban;
    reportParams.psid = psid;
    reportParams.crmId = crmId;

    report(reportParams);
}

export function dwhExtendedOtpButtonClicked(worldType, customerName, subscriber, idNumber, ban, param9) {
    let reportParams = getReportParams();
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'My Zone';
    reportParams.channel = 'WebsitePrivate';
    reportParams.actionType = `MyZone ${worldType} Lobby`;
    reportParams.status = 'Ongoing';
    reportParams.messageText = 'OTP Extended Button Clicked';
    reportParams.param9 = param9;
    reportParams.customerName = customerName;
    reportParams.idNumber = idNumber;
    reportParams.subscriber = subscriber;
    reportParams.banId = ban;
    report(reportParams);
}
